import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    }
  },

  render
}
